module.exports = {
	"id": "BJ",
	"name": "Benin",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.002223,
			"5": null,
			"6": 0.004446,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.006669,
			"11": 0.028899,
			"12": 0.024453,
			"13": 0.006669,
			"14": 0.020007,
			"15": 0.013338,
			"16": 0.013338,
			"17": 0.048906,
			"18": 0.020007,
			"19": 0.011115,
			"20": 0.004446,
			"21": 0.002223,
			"22": 0.026676,
			"23": 0.011115,
			"24": 0.011115,
			"25": 0.033345,
			"26": 0.042237,
			"27": 0.015561,
			"28": 0.011115,
			"29": 0.035568,
			"30": 0.02223,
			"31": 0.062244,
			"32": 0.017784,
			"33": 0.068913,
			"34": 0.008892,
			"35": 0.004446,
			"36": 0.042237,
			"37": 0.006669,
			"38": 0.035568,
			"39": 0.020007,
			"40": 0.046683,
			"41": 0.008892,
			"42": 0.035568,
			"43": 0.113373,
			"44": 0.020007,
			"45": 0.08892,
			"46": 0.126711,
			"47": 0.171171,
			"48": 0.080028,
			"49": 0.904761,
			"50": 0.04446,
			"51": 0.417924,
			"52": 0.28899,
			"53": 6.986889,
			"54": 1.974024,
			"55": 0.006669,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": 0.026676,
			"3": 0.055575,
			"4": 0.004446,
			"5": null,
			"6": null,
			"7": 0.006669,
			"8": 0.006669,
			"9": null,
			"10": 0.004446,
			"11": 0.013338,
			"12": 0.011115,
			"13": null,
			"14": 0.004446,
			"15": 0.013338,
			"16": 0.015561,
			"17": null,
			"18": 0.013338,
			"19": 0.004446,
			"20": 0.011115,
			"21": 0.008892,
			"22": 0.008892,
			"23": 0.017784,
			"24": 0.015561,
			"25": 0.015561,
			"26": 0.017784,
			"27": 0.015561,
			"28": 0.017784,
			"29": 0.035568,
			"30": 0.024453,
			"31": 0.024453,
			"32": 0.033345,
			"33": 0.02223,
			"34": 0.017784,
			"35": 0.026676,
			"36": 0.024453,
			"37": 0.040014,
			"38": 0.064467,
			"39": 0.048906,
			"40": 0.037791,
			"41": 0.071136,
			"42": 0.048906,
			"43": 0.495729,
			"44": 0.100035,
			"45": 0.075582,
			"46": 0.062244,
			"47": 0.537966,
			"48": 0.42237,
			"49": 3.103308,
			"50": 0.2223,
			"51": 0.02223,
			"52": null,
			"3.5": 0.002223,
			"3.6": 0.013338
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.002223,
			"15": 0.004446,
			"16": null,
			"17": null,
			"18": 0.031122,
			"19": 0.004446,
			"20": 0.008892,
			"21": 0.013338,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.004446,
			"29": 0.006669,
			"30": 0.002223,
			"31": null,
			"32": 0.002223,
			"33": 0.004446,
			"34": 0.006669,
			"35": 0.017784,
			"36": 0.020007,
			"37": 0.260091,
			"38": 0.024453,
			"39": 0.017784,
			"40": 0.589095,
			"41": 0.060021,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.002223,
			"11.6": 0.013338,
			"12.1": 0.026676
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.071136,
			"9": 0.071136,
			"10": 0.182286,
			"3.1": null,
			"3.2": null,
			"5.1": 0.011115,
			"6.1": null,
			"7.1": null,
			"9.1": 0.226746
		},
		"ios_saf": {
			"8": 0,
			"10": 0.632643732723,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0170490165487,
			"8.1-8.4": 0.0314973356578,
			"9.0-9.2": 0.0150262518734,
			"9.3": 0.229246663197
		},
		"android": {
			"3": 0,
			"4": 0.0755393875969,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00944242344961,
			"4.1": 0.272481362403,
			"4.2-4.3": 0.681203406008,
			"4.4": 1.56204662209,
			"4.4.3-4.4.4": 1.57553579845
		},
		"ie": {
			"6": 0.011188125,
			"7": 0.002237625,
			"8": 0.127544625,
			"9": 0.024613875,
			"10": 0.06712875,
			"11": 0.447525,
			"5.5": null
		},
		"op_mob": {
			"0": 3.79877221072,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.105521450298
		},
		"edge": {
			"12": 0.064467,
			"13": 0.080028,
			"14": 0.095589
		},
		"ie_mob": {
			"10": 0.194753605634,
			"11": 0.792925394366
		},
		"bb": {
			"7": 0.05249475,
			"10": null
		},
		"samsung": {
			"0": 0.769923
		},
		"and_uc": {
			"0": 5.093935
		},
		"op_mini": {
			"0": 51.180197339
		},
		"and_chr": {
			"0": 11.236158
		},
		"and_ff": {
			"0": 0.023331
		}
	},
	"total": 98.83911475
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BJ.json
 ** module id = 479
 ** module chunks = 0
 **/